 
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
//page links  
import './statusbar.css';
import { VscArrowLeft } from "react-icons/vsc";
import { IoIosHelpCircle, IoIosHelpCircleOutline } from "react-icons/io";
import { MdSearch, MdAdd, MdSettings, MdDisplaySettings, MdMoreHoriz, MdStar, MdOutlineAddTask, MdAddToQueue, MdClose, MdCopyAll, MdArrowBackIos } from 'react-icons/md';
export default function Statusbar({ data }) {
  const navigate = useNavigate();
  const location = useLocation();
  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // Go back
    } else {
      navigate('/'); // No history, go to home
    }
  };
  return (
    <div className="status-bar">
      <div className="container_size">
        <div className="status-bar_size">
          <div className='left_body'>
            <MdArrowBackIos onClick={handleGoBack} className='back_arrow_btn' />
          </div>
          <div className='name-bar-body'>{data}</div>
          <div className='right_body'>
            <div
              onClick={() => navigate('/help')}
              className={`menubutton-icon ${location.pathname === '/help' ? 'active' : ''}`}
              title="Help Center"
            >
              {location.pathname === '/help' ? <IoIosHelpCircle className="icon" /> : <IoIosHelpCircleOutline className="icon" />}
 
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
